import http from "@/http-common";

class BirthdayStatisticsService {
  getMonthly(month) {
    return http.get("statistics/birthday/monthly", { params: { month } });
  }
}

export default new BirthdayStatisticsService();
